import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { Meta } from './style.js';
export const PaymentPlanDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(PaymentPlanDetailsContent, { blamelog: blamelog })))));
};
const PaymentPlanDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.PaymentPlanCreate:
            return React.createElement(PaymentPlanCreateContent, { blamelog: blamelog });
        case BlameLogType.PaymentPlanPatched:
            return React.createElement(PaymentPlanPatchedContent, { blamelog: blamelog });
        case BlameLogType.PaymentPlanDelete:
            return React.createElement(PaymentPlanDeleteContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const PaymentPlanCreateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null, details.entriesCount != null && (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.entriesCount)),
        React.createElement("td", null, details.entriesCount)))));
};
const PaymentPlanPatchedContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null, details.statusChange && (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromStatus)),
            React.createElement("td", null, details.statusChange.from)),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.toStatus)),
            React.createElement("td", null, details.statusChange.to))))));
};
const PaymentPlanDeleteContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.previousStatus && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.previousStatus)),
            React.createElement("td", null, details.previousStatus))),
        details.reason && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.reason)),
            React.createElement("td", null, details.reason)))));
};
//# sourceMappingURL=PaymentPlanDetails.js.map